import { COLUMN_NAMES } from './columnNames';

import styles from '../components/table/GovernanceTagsTableController.module.scss';

export const GOVERNANCE_TAGS_TABLE_COLUMNS = [
  { name: COLUMN_NAMES.RESOURCE_COST, title: 'Resource Cost' },
  { name: COLUMN_NAMES.RESOURCE_NAME, title: 'Resource Name' },
  { name: COLUMN_NAMES.RESOURCE_ID, title: 'Resource ID' },
  { name: COLUMN_NAMES.SERVICE, title: 'Service' },
  { name: COLUMN_NAMES.REGION, title: 'Region' },
  { name: COLUMN_NAMES.LINKED_ACCOUNT, title: 'Linked Account' },
  { name: COLUMN_NAMES.TAGS, title: 'Tags' },
  { name: COLUMN_NAMES.GOVERNANCE_TAGS, title: 'Virtual Tags', headerClassName: styles.virtualTagsColumn },
  { name: COLUMN_NAMES.LAST_UPDATE, title: 'Last Update', headerClassName: styles.lastUpdateColumn },
  { name: COLUMN_NAMES.GOVERNANCE_TAG_ACTION, title: '', headerClassName: styles.virtualTagActionColumn },
  { name: COLUMN_NAMES.TAG_ICON, title: '', headerClassName: styles.tagIconColumn },
];
